// XP → level 1–10, shared across machines (HANDOVER §6). Levels drive Map unlockables.
export const LEVEL_XP = [0, 40, 100, 180, 280, 400, 550, 750, 1000, 1300] as const

export function levelFor(xp: number): number {
  let level = 0
  for (const at of LEVEL_XP) if (xp >= at) level++
  return level
}

/** Progress within the current level, 0..1 (1 at max level). */
export function levelProgress(xp: number): number {
  const lv = levelFor(xp)
  if (lv >= LEVEL_XP.length) return 1
  const from = LEVEL_XP[lv - 1]!
  const to = LEVEL_XP[lv]!
  return (xp - from) / (to - from)
}
